'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../app/store';

import { Filters } from '../features/cfs-hub/filters.jsx';

export function renderSearch() {
	const $cfsFilters = $.findByBem('cfs-hub-filters');
	const initialState = $cfsFilters.data('initial-state');
	const filterContext = $cfsFilters.data('filter-context');

	const filtersRoot = ReactDOM.createRoot(document.getElementById('cfs-hub-filters'));
	filtersRoot.render(
		<Provider store={store}>
			<Filters initialState={initialState} filterContext={filterContext} />
		</Provider>
	);
}